import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { BetslipType } from 'packages/sports/common/betslip/core/betslip-type';

import { BetBuilderPick } from '../../models';

@Component({
    selector: 'bs-linear-bet-builder-pick-display',
    templateUrl: './linear-bet-builder-pick-display.component.html',
    styleUrls: ['./linear-bet-builder-pick-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearBetBuilderPickDisplayComponent {
    @Input() pick: BetBuilderPick;
    @Input() selectionState: { isSelected: boolean; isLocked: boolean };
    @Input() showHeader: boolean;
    @Input() showEditButton: boolean;
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() betslipType: BetslipType;

    constructor(sitecore: Sitecore) {
        this.addPicksMessage = sitecore.betslip.linear.BabAddPicks;
    }

    readonly addPicksMessage: string;
}
